import { AxiosResponse } from 'axios';
import { useQueries, QueryKey, UseQueryResult } from 'react-query';

const useApiFetches = <ResponseType = any>(
  queries: Array<{
    queryKey: QueryKey;
    fn: () => Promise<AxiosResponse<ResponseType>>;
  }>
): UseQueryResult<ResponseType>[] => {
  return useQueries([
    ...queries.map(({ queryKey, fn }) => ({
      queryKey,
      queryFn: async () => {
        const { data } = await fn();
        return data;
      },
    })),
  ]);
};

export default useApiFetches;
